"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isColumnsAllowed = isColumnsAllowed;
exports.StackContainer = void 0;

var _native = _interopRequireDefault(require("styled-components/native"));

var _StackHelper = require("./Stack-helper");

var _props = require("@sloth-system/props");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defaultValues(props) {
  let {
    dir: direction = "horizontal",
    distribution = "start",
    alignment = "center",
    gap = 10,
    ...rest
  } = props;
  return {
    direction,
    distribution,
    alignment,
    gap,
    ...rest
  };
}

function isColumnsAllowed(props) {
  let {
    direction,
    columns
  } = defaultValues(props);

  if (direction === "vertical" || !Array.isArray(columns)) {
    return false;
  }

  return true;
}

function flexStyles(props) {
  let {
    direction,
    distribution,
    alignment
  } = defaultValues(props);
  let flexDirection = (0, _StackHelper.toFlexDirection)(direction);
  let justifyContent = (0, _StackHelper.toFlexJustifyOrAlignment)(distribution);
  let alignItems = (0, _StackHelper.toFlexJustifyOrAlignment)(alignment);
  return `
    flex-direction: ${flexDirection};
    justify-content: ${justifyContent};
    align-items: ${alignItems};
  `;
}

function gapStyles(props) {
  let {
    distribution,
    direction,
    gap
  } = defaultValues(props);

  if (isGapDisabled(distribution)) {
    return "";
  }

  let margin = `margin: 0 0 0 0;`;
  let firstChildMargin = ``;
  let lastChildMargin = ``;

  if (direction === "horizontal") {
    margin = `margin: 0 ${gap / 2}px 0 ${gap / 2}px;`;
    firstChildMargin = `margin-right: 0;`;
    lastChildMargin = `margin-left: 0;`;
  } else {
    margin = `margin: ${gap / 2}px 0 ${gap / 2}px 0;`;
    firstChildMargin = `margin-top: 0;`;
    lastChildMargin = `margin-bottom: 0;`;
  }

  return `
    & > * {
      ${margin}
    }
    & > *:first-child {
      ${firstChildMargin}
    }
    & > *:last-child {
      ${lastChildMargin}
    }
  `;
}

function isGapDisabled(distribution) {
  return distribution === "space-around" || distribution === "space-between" || distribution === "space-evenly";
} // columns doesn't have affect on vertical direction


function columns(props) {
  if (!isColumnsAllowed(props)) {
    return "";
  }

  let generatedCss = "flex-wrap: wrap;";
  return generatedCss;
}

var StackContainer = _native.default.View`
  display: flex;
  ${flexStyles}
  ${gapStyles}
  ${_props.paddingProps}
  ${_props.backgroundColorProps}
  ${columns}
`;
exports.StackContainer = StackContainer;